import * as importConstant from './constants'

export const importReportNhaCCRequest = (formData) => {
  return {
    type: importConstant.IMPORT_REPORT_NCC_REQUESTING,
    formData
  }
}
export const importReportNhaCCSuccess = (data) => {
  return {
    type: importConstant.IMPORT_REPORT_NCC_SUCCESS,
    data
  }
}

export const importReportNhaCCError = (error) => {
  return {
    type: importConstant.IMPORT_REPORT_NCC_ERROR,
    error
  }
}
export const importReportKhoRequest = (formData) => {
  return {
    type: importConstant.IMPORT_REPORT_KHO_REQUESTING,
    formData
  }
}
export const importReportKhoSuccess = (data) => {
  return {
    type: importConstant.IMPORT_REPORT_KHO_SUCCESS,
    data
  }
}

export const importReportKhoError = (error) => {
  return {
    type: importConstant.IMPORT_REPORT_KHO_ERROR,
    error
  }
}

export const importReportListRequest = (formData) => {
  return {
    type: importConstant.IMPORT_REPORT_LIST_REQUESTING,
    formData
  }
}

export const importReportListSuccess = (data) => {
  return {
    type: importConstant.IMPORT_REPORT_LIST_SUCCESS,
    data
  }
}

export const importReportListError = (error) => {
  return {
    type: importConstant.IMPORT_REPORT_LIST_ERROR,
    error
  }
}

export const importExportXlsRequest = (formData, callback) => {
  return {
    type: importConstant.IMPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const importExportXlsSuccess = (data) => {
  return {
    type: importConstant.IMPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const importExportXlsError = (error) => {
  return {
    type: importConstant.IMPORT_EXPORT_XLS_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/ImportReport/actions.js